<template>
  <b-modal
    id="photo"
    size="lg"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    style="width: 20%"
    :visible="showModal"
    @hidden="closePhoto"
  >
    <header class="d-flex align-items-center justify-content-between pb-3">
      <section class="b-modal-header">Preview {{ label }}</section>

      <section class="rotate-on-hover pointer" @click="closePhoto">
        <img
          v-b-tooltip.hover.top="'Close'"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt
        />
      </section>
    </header>
    <div
      v-if="loading"
      class="
        d-flex
        justify-content-center
        align-items-center
        modal-loader-height
      "
    >
      <b-spinner class="text-center" label="loading..."></b-spinner>
    </div>
    <div v-else class="pr-1">
      <img :src="link" style="width: 100%" alt="" />
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "PreviewImage",
  props: {
    showModal: Boolean,
    link: String,
    label: String,
  },
  data() {
    return {
      loading: true,
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  methods: {
    // closee candidate uploaded image  modal
    closePhoto() {
      this.$emit("close-modal");
    },
  },
};
</script>
<style>
.modal-loader-height {
  height: 350px;
}
</style>
